import "./App.css";
import PaymentForm from "./PaymentForm";

function App() {
  return (
    <div className="App">
      <PaymentForm />
    </div>
  );
}

export default App;
